import React, { useEffect } from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';
import { Container } from '../../../../symphony';

import { IAction } from '../../global-interface';
import { SlLEContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';

import s from './ActionOnMountWrapper.scss';
import { IMaterial, IMaterialInfo } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';

interface IActionOnMountWrapperProps {
	children: IMaterial[] | IMaterialInfo[] | JSX.Element[];
	action: IAction;
	id: number;
}
export function ActionOnMountWrapper({
	children,
	action,
	id,
}: IActionOnMountWrapperProps): JSX.Element {
	useStyles(s);
	useEffect(() => {
		const { actions$ } = Container.take(SlLEContext, SlActions);
		actions$.next(action);
	}, []);

	return (
		<div sl-test-data={`cmpWrapper-${id}`} className="le-mount-wrapper">
			{children}
		</div>
	);
}
